import { BetterEnum } from '@cims-online/shared'
import { GroupSelectValue } from '../../../../GroupSelect/types'
import { CreateGoogleSheetValues } from './CreateGoogleSheetBody/types'

export interface CreateBodyValues extends GroupSelectValue {
  name?: string
  googleSheet?: CreateGoogleSheetValues
}

/**
 * this feels like overkill, but we're adding the extensibility now instead of
 * later
 */
export const ConnectionType = {
  GoogleSheet: 'Google Sheet',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ConnectionType = BetterEnum<typeof ConnectionType>
